/**
 * Minimal top bar for delivery staff (Orders + Order alerts + Logout).
 */
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
} from '@mui/material';
import {
  clearStaffSession,
  getStaffSession,
  staffAppPath,
} from '../lib/deliveryStaffApi';

export default function DeliveryStaffShell({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const session = getStaffSession();
  const name = session.displayName || 'Staff';

  const go = (path) => navigate(staffAppPath(path));

  const logout = () => {
    clearStaffSession();
    navigate(staffAppPath('/delivery-staff/login'), { replace: true });
  };

  const onOrders =
    location.pathname.includes('/delivery-staff/orders') ||
    location.pathname.endsWith('/delivery-staff');
  const onAlerts = location.pathname.includes('notifications-help');

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f3f7f6' }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: '#0f766e',
          borderBottom: '1px solid rgba(255,255,255,0.12)',
        }}
      >
        <Toolbar sx={{ gap: 1, flexWrap: 'wrap', minHeight: 56 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {title || 'Delivery'}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.9 }}>
              {name}
            </Typography>
          </Box>
          <Button
            size="small"
            variant={onOrders ? 'contained' : 'text'}
            onClick={() => go('/delivery-staff/orders')}
            sx={{
              color: '#fff',
              textTransform: 'none',
              fontWeight: 700,
              bgcolor: onOrders ? 'rgba(255,255,255,0.2)' : 'transparent',
            }}
          >
            Orders
          </Button>
          <Button
            size="small"
            variant={onAlerts ? 'contained' : 'text'}
            onClick={() => go('/delivery-staff/notifications-help')}
            sx={{
              color: '#fff',
              textTransform: 'none',
              fontWeight: 700,
              bgcolor: onAlerts ? 'rgba(255,255,255,0.2)' : 'transparent',
            }}
          >
            Order alerts
          </Button>
          <Button
            size="small"
            onClick={logout}
            sx={{ color: '#fff', textTransform: 'none', opacity: 0.9 }}
          >
            Log out
          </Button>
        </Toolbar>
      </AppBar>
      {children}
    </Box>
  );
}
